module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('p', {
    staticClass: "chap-title"
  }, [_c('span', [_vm._v("ONE")])]), _vm._v(" "), _c('p', {
    staticClass: "normal"
  }, [_vm._v("“State your name, please.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“John Marshall Tanner.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Are you a resident of the city and county of San Francisco?”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Yes, I am.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“What is your business, Mr. Tanner?”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“I’m a private investigator.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Licensed by the State of California?”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Yes.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“How long have you been a private detective?”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“A little over ten years.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“And what did you do before that?”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“I was a lawyer.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“In this city?”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Yes.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“How long did you practice law?”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Approximately eight years.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Are you still a member of the bar of this state, Mr. Tanner?”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Yes.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“But you no longer practice law.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“That’s correct. But I occasionally accept a retainer.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Why is that?”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“It allows me to keep certain information confidential pursuant to the attorney-client privilege. I find that useful, and my clients find it reassuring.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“I see. Now, let me turn your attention to this past October, approximately a year ago. At that time did you have occasion to discuss certain business affairs of the plaintiff in this case, Mr. Malcolm Halliburton?”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Yes, I did.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“With whom did you have that discussion?”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“With you, Mr. Stacey.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Pursuant to that discussion, were you engaged in your professional capacity to perform services for the defendant in this case, the Arundel Corporation?”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“I was.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“And what were those services?”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“I was given a copy of the resumé Mr. Halliburton had included with his application for the position of vice-president of international marketing for Arundel Corporation, and I was asked to verify certain items of personal history listed on that resumé.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Were you told why?”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“I was.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“What were you told?”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Objection. Hearsay.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“It goes to his state of mind, Your Honor.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“The jury is cautioned that the answer will be admitted solely to show the state of mind of the witness, and not for the truth of the matters asserted. You may answer the question, Mr. Tanner.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Thank you, Your Honor. I was told that Mr. Halliburton had been hired by Arundel in 1979; that his contract contained certain bonus and incentive provisions which were highly lucrative; that over the next five years Mr. Halliburton had not performed pursuant to Arundel’s expectations in that certain of his activities were being investigated for possible illegalities, including embezzlement and bribery; that in view of these irregularities the company had decided to terminate Mr. Halliburton’s employment; and that shortly after his termination Mr. Halliburton had filed suit to collect the amounts he felt were due and owing to him pursuant to his employment contract. As part of its defense to that lawsuit, the corporation wanted to ascertain whether Mr. Halliburton’s employment application had been truthful and complete in all respects, or whether it had been fraudulent and misleading in certain particulars.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“So essentially you were asked to verify the employment application.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Right.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“And if you found any errors or omissions what were you to do?”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Report them to you and try to ascertain the correct information.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“How long did you work at this project, Mr. Tanner?”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“For two months, on and off. For a total of seventy-five hours, approximately.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Did you incur significant expenses?”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Yes. There was a good deal of travel involved. I went to Durham, North Carolina; Providence, Rhode Island; Washington, D.C.; and to Massachusetts, Missouri, and Iowa as well.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Now, I show you a copy of what has been marked Defendant’s Exhibit D. Can you identify that for me?”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“That is what you have given to me and described as the resumé attached to the employment application that Mr. Halliburton submitted to Arundel Corporation back in 1979.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Tell me, Mr. Tanner. What items on that resumé did you find to be true?”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Objection, Your Honor. No foundation.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Your Honor, plaintiff has previously admitted pursuant to Section 2033 of the Code of Civil Procedure that certain affidavits and other documents obtained by Mr. Tanner during his investigation were authentic and genuine. Those documents will be offered into evidence after Mr. Tanner completes his testimony, as providing the foundation for that testimony. If at this late date counsel for Mr. Halliburton seeks to challenge the authenticity of these documents, I assure him that we will move pursuant to CCP Section 2034(c) for an order requiring plaintiff to pay the expenses of any and all affiants and records custodians forced to travel to this court to authenticate the documents, and for reasonable attorneys’ fees as well. Are you making such a challenge, Mr. Kinlaw?”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Our position regarding the documentation will be asserted when and if they are offered into evidence, Mr. Stacey, and not before.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“May I proceed, then, Your Honor?”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“You may, Mr. Stacey. Subject to a motion to strike if a sufficient foundation is not forthcoming.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Thank you. So, Mr. Tanner. Tell us, for example, what you learned of Mr. Halliburton’s place and date of birth.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“His resumé says he was born in Paris, France, in 1939. Actually, he was born in What Cheer, Iowa, in 1945.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“How big a city is What Cheer?”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“In the 1980 census the population of What Cheer was eight hundred and three.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“How about Mr. Halliburton’s education?”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“His resumé states that he attended Governor Dummer Academy in Massachusetts, then Brown University, the London School of Economics, and the graduate school of business at Duke University. It also states he was awarded the degrees of Bachelor of Arts, a Master of Arts in Economics, and a Master of Business Administration. Actually, Mr. Halliburton graduated from high school in Moravia, Iowa, and attended Northeast Missouri State Teachers College in Kirksville, Missouri, on a football scholarship. He dropped out after two years when a knee injury ended his athletic career. Mr. Halliburton is still remembered by several merchants in Kirksville, as owing them sizable amounts for food, clothing, and other necessaries which were extended to him on credit during his college days.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Your Honor, move to strike the final portion of that answer as hearsay. I know of no affidavits on that point. The matter is also immaterial.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Read the answer please, Mr. Reporter. Thank you. The objection is sustained, Mr. Kinlaw. The jury will disregard everything following the word "), _c('i', [_vm._v("career.")]), _vm._v(" You know better, Mr. Tanner.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“I’m sorry, Your Honor. I got carried away by my intrepidity.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Continue, Mr. Stacey.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Thank you, Your Honor. So Mr. Halliburton has no college degree, to say nothing of a Master’s in Business Administration?”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“He has no degrees from the institutions he listed, and I found no evidence that he attended any educational institutions other than Northeast Missouri State and Moravia High.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“How about his employment record?”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“His resumé states that he was employed by Exxon Corporation, and he was, but not as an assistant vice-president of bulk product marketing, as he represented.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“In what capacity was he employed?”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“As a gas station attendant in Washington, D.C. The station was on Connecticut Avenue.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“How about his other position, that of Chief Executive Officer of Halliburton, Incorporated?”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“That much is true. He did hold that position in that company. But the company did not have assets in excess of thirty million dollars and it did not have more than one hundred employees and it did not engage in the manufacture and distribution of computer software.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“What were its assets and what was its business, Mr. Tanner?”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Halliburton, Incorporated owned a 1973 Dodge Challenger and not much else. What it did was sell the contents of its trunk—which ranged from Gucci shoes from Mexico to Navajo jewelry from Taiwan—at various outdoor locations in the Washington–Baltimore corridor. Most of the locations were vacant lots.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“I see. Was there anything at all on that resumé that was the truth, Mr. Tanner?”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Well, Mr. Halliburton said he was a skilled and experienced salesman, and I’d say there was some truth to that.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Why?”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“He did a damned good job of selling himself to the Arundel Corporation.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Thank you, Mr. Tanner. Your Honor, I submit the aforementioned affidavits and other documents which support Mr. Tanner’s testimony, which have been stipulated as authentic and which have been collectively marked as Defendant’s F.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Any objection, Mr. Kinlaw?”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Ah … no, Your Honor.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“It may be admitted.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“No further questions, Your Honor.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“You may cross-examine, Mr. Kinlaw.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Thank you, Your Honor. Mr. Tanner, you’re a private eye, right?”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Right.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“For sale to the highest bidder.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Not always.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“But usually?”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Maybe not even that. I look at the bidder as well as the bid.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Come now, Mr. Tanner. You testify in court quite often, do you not?”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“I suppose I do.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“And you get paid for it, true?”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Yes.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“You’re being paid for the testimony you just gave, aren’t you, Mr. Tanner?”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“I’m being paid for my time, Mr. Kinlaw, not for my testimony.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“At what rate?”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Forty dollars per hour.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“That’s quite a lot, isn’t it?”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“I happen to know it’s only one fifth of what you charge for "), _c('i', [_vm._v("your")]), _vm._v(" time, Mr. Kinlaw.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“That’s hardly the point, is it?”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“I don’t know. You brought it up.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“I … Now, you’ve testified for Mr. Stacey several times before, have you not? In other cases?”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Twice.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“How did those come out?”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Won one, lost one.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Did you receive a bonus afterward, in either case?”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“No.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Are you sure?”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“I am. And so is my banker.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“I see. Now, you don’t know of your own personal knowledge or experience that Mr. Halliburton lacks an MBA degree, do you, Mr. Tanner?”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“No.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“And you don’t know whether he ever sold computer software for a living, do you?”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“No. I just know he didn’t sell it for Halliburton, Incorporated.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“So as far as you know, the essential parts of Mr. Halliburton’s resumé may well be true, isn’t that right?”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“I guess it depends on what you mean by essential. He got his name and address right. And the color of his eyes. But I imagine the Arundel Corporation sees that resumé as a rather expensive hoax.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Move to strike as nonresponsive, Your Honor.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Overruled.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“But—”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Proceed, Mr. Kinlaw.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Very well. Let’s turn to your previous profession, Mr. Tanner. You say you used to be a practicing attorney, but now you’re not. I wonder if you can tell me why you’re not a lawyer anymore.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“There’s not an easy answer to that. A lot of it had to do with not liking to talk on the telephone, I think.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Come now, Mr. Tanner. There was more to it than that, was there not?”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“I suppose there must have been.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“You got in some trouble, didn’t you? Trouble that resulted in a jail term.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“What I got into was a situation in which I felt it necessary to make certain observations in order to protect my client’s rights. The person to whom I made those observations didn’t take them kindly. Since he happened to be a judge, he sentenced me to six months in jail for contempt of court. I served the time rather than apologize. After I got out I decided that since none of the reasons for my contemptuous outburst had disappeared, I’d try to get into a more respectable line of work.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“More respectable? Surely you don’t expect me to believe that a private detective pursues a more respectable calling than an attorney-at-law.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“No, Mr. Kinlaw. I don’t expect "), _c('i', [_vm._v("you")]), _vm._v(" to believe that. But I think the jury might.”")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-335648f2","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/xhtml/chapter001.vue
// module id = 72
// module chunks = 0